import React from 'react';

import { Typography } from '@mui/material';
import { ColumnDefinition, HeadCellFilterType } from 'components/Common/DataTable/DataTableTypes';
import { JBColors } from '@juliusbaer-gcrm/gcrm-frontend-components';
import { ContactNotePartner } from 'types/ContactNote';

export const RelatedPartnersHeadcells: ColumnDefinition<ContactNotePartner>[] = [
  {
    id: 'fullName',
    label: 'Full name',
    filter: HeadCellFilterType.SORT,
    color: JBColors.support.greenSmoke[80],
    width: '50%',
    render: function Render(row: ContactNotePartner) {
      return <Typography> {row.fullName ?? '-'} </Typography>;
    },
  },
  {
    id: 'partnerUId',
    label: 'Relationship manager',
    filter: HeadCellFilterType.EMPTY,
    color: JBColors.support.greenSmoke[80],
    width: '50%',
    render: function Render(row: ContactNotePartner) {
      return (
        <Typography>
          {row.relationshipManager ? `${row.relationshipManager?.fullName} (${row.relationshipManager?.uid})` : '-'}
        </Typography>
      );
    },
  },
];
